import useApiMutation from '_api/mutations/useApiMutation';
import { PasswordResetPayload } from '_api/types';

export const RESET_PASSWORD = 'reset-password';

export const usePasswordReset = () => {
  return useApiMutation<any, PasswordResetPayload>(
    () => '/user/password-reset',
    'post',
    undefined,
    {
      mutationKey: [RESET_PASSWORD],
    },
    (body: PasswordResetPayload) => JSON.stringify(body),
  );
};
